import {Box, Button, IconButton, Menu, styled} from "@mui/material";
import React, {useState} from "react";
import logoCropped from "../../assets/mini_logo_text_round_bg.png";
import MenuIcon from "@mui/icons-material/Menu";

const HeaderContainer = styled("header")({
    height: "60px",
    width: "100%",
    background: "transparent",
    borderImage: "linear-gradient(90deg, #05080c, #6d7985, #05080c) 100",
    borderBottom: "2px solid",
    position: "fixed",
    zIndex: 6,
    backdropFilter: "blur(6px)",
    display: "flex",
    justifyContent: "space-between",
    padding: "0 20px",
    boxSizing: "border-box",
    alignItems: "center",
});

const Logo = styled("a")({
    background: `url(${logoCropped})`,
    height: "90%",
    width: "60px",
    cursor: "pointer"
});

const HeaderButtonsContainer = styled(Box)({
    "@media(max-width: 768px)":{
        display: "flex",
        flexDirection: "column"
    }
});

const HeaderButton = styled(Button)({
    color: "#FFFFFF",
});

const Header = ():JSX.Element => {
    
    const [anchorEl, setAnchorEl] = useState<null | HTMLAnchorElement | HTMLButtonElement>(null);
    
    const renderMenuItems = ():React.ReactNode => {
        return <HeaderButtonsContainer>
            <HeaderButton href={"#executivesummary"}>
                Executive Summary
            </HeaderButton>
            <HeaderButton href={"#aitechnology"}>
                AI Technology
            </HeaderButton>
            <HeaderButton href={"#interactiveexamples"}>
                Interactive Examples
            </HeaderButton>
            <HeaderButton href={"#userscenarios"}>
                User Scenarios
            </HeaderButton>
            <HeaderButton href={"#roadmap"}>
                Roadmap
            </HeaderButton>
            <HeaderButton href={"#team"}>
                Team
            </HeaderButton>
        </HeaderButtonsContainer>;
    };
    
    return (
        <HeaderContainer>
            <Logo href={"#intro"}>
                <img src={logoCropped} height={"100%"} alt={"logo"}/>
            </Logo>
            {window.innerWidth > 768 && renderMenuItems()}
            {window.innerWidth <= 768  && <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
                <MenuIcon htmlColor={"#FFFFFF"}/>
            </IconButton>}
            <Menu open={!!anchorEl} anchorEl={anchorEl} onClose={() => setAnchorEl(null)}>
                {renderMenuItems()}
            </Menu>
        </HeaderContainer>
    );
};

export default Header;
